import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import { getImageCardSectionFields } from '../../utils/landingPageData';

// New SVG icon components for carousel controls

const RightShevron = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
	>
		<path
			d='M7.14296 16.4285L13.5715 9.9999L7.14296 3.57133'
			stroke='#222222'
			strokeWidth='2'
		/>
	</svg>
);
const LeftShevron = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
	>
		<path
			d='M12.8572 3.57153L6.42859 10.0001L12.8572 16.4287'
			stroke='#222222'
			strokeWidth='2'
		/>
	</svg>
);
const RightArrowIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='45'
		height='44'
		viewBox='0 0 45 44'
		fill='none'
	>
		<rect
			x='-0.5'
			y='0.5'
			width='43'
			height='43'
			rx='21.5'
			transform='matrix(-1 0 0 1 43.1328 0)'
			fill='white'
		/>
		<rect
			x='-0.5'
			y='0.5'
			width='43'
			height='43'
			rx='21.5'
			transform='matrix(-1 0 0 1 43.1328 0)'
			stroke='#BCBCBC'
			strokeWidth='1'
		/>
		<path
			d='M19.6325 29.9264L18.75 29.0439L24.9256 22.8683C25.0428 22.7511 25.1086 22.5921 25.1086 22.4264C25.1086 22.2607 25.0428 22.1017 24.9256 21.9845L18.7606 15.8208L19.6444 14.937L25.8081 21.1008C26.1596 21.4524 26.3571 21.9292 26.3571 22.4264C26.3571 22.9236 26.1596 23.4004 25.8081 23.752L19.6325 29.9264Z'
			fill='#222222'
		/>
	</svg>
);
const LeftArrowIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='45'
		height='44'
		viewBox='0 0 45 44'
		fill='none'
	>
		<rect
			x='1.36719'
			y='0.5'
			width='43'
			height='43'
			rx='21.5'
			fill='white'
			stroke='#BCBCBC'
			strokeWidth='1'
		/>
		<path
			d='M25.3675 29.9264L26.25 29.0439L20.0744 22.8683C19.9572 22.7511 19.8914 22.5921 19.8914 22.4264C19.8914 22.2607 19.9572 22.1017 20.0744 21.9845L26.2394 15.8208L25.3556 14.937L19.1919 21.1008C18.8404 21.4524 18.6429 21.9292 18.6429 22.4264C18.6429 22.9236 18.8404 23.4004 19.1919 23.752L25.3675 29.9264Z'
			fill='#222222'
		/>
	</svg>
);

const SectionContainer = styled.div`
	display: flex;
	padding: 80px 0px 64px 0px;
	flex-direction: column;
	align-items: center;
	gap: 56px;
	background: #fcf0e3;
	${({ bgColor }) => bgColor && `background: ${bgColor}!important;`}
	${({ textColor }) =>
		textColor &&
		`
		&& .section-header h2,
		&& .section-header p,
		&& .image-card .card-eyebrow,
		&& .image-card .card-title,
		&& .image-card .card-copy {
			color: ${textColor} !important;
		}
	`}
	.fox & {
		background: var(
			--Fox-Primary-Blue-300,
			linear-gradient(
				0deg,
				rgba(255, 255, 255, 0.8) 0%,
				rgba(255, 255, 255, 0.8) 100%
			),
			#2954b6
		);
	}
	.law & {
		background: #e9ecef;
	}
	.osw & {
		background: #e8eef1;
	}
	.npr & {
		background: #f8f5ef;
	}

	.bon & {
		background: #f2f2f8;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 40px 12px;
		gap: 40px;
		align-items: unset;
	}
	${EmotionBreakpoint('mobile')} {
		padding: 40px 12px;
		gap: 40px;
		align-items: unset;
	}
	.fox & {
		.section-header {
			${EmotionBreakpoint('tablet')} {
				padding-left: 0px !important;
			}
			${EmotionBreakpoint('mobile')} {
				padding-left: 0px !important;
			}
		}
	}
	.section-header {
		display: flex;
		flex-direction: column;
		gap: 24px;
		h2 {
			color: var(--WSJ-Primary-Ink-Black, #2b2a2f);
			text-align: center;
			font-family: 'Escrow Banner Compressed';
			font-size: 40px;
			font-style: normal;
			font-weight: 500;
			line-height: 112%;
			${EmotionBreakpoint('tablet')} {
				font-size: 32px;
				line-height: 32px;
			}
			${EmotionBreakpoint('mobile')} {
				font-size: 32px;
				line-height: 32px;
			}
			.wsj & {
				text-transform: uppercase;
			}
			.law & {
				font-family: 'Oswald';
				text-transform: uppercase;
			}
			.bon & {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: 'FuturaPT';
				font-size: 32px;
				font-style: normal;
				font-weight: 600;
				line-height: 40px; /* 125% */
				letter-spacing: 1.28px;
				text-transform: uppercase;
			}
			.osw & {
				font-family: 'Neue Aachen Pro';
				font-size: 40px;
				padding-left: 0;
			}
			.npr & {
				font-family: 'Gotham';
				font-weight: 325;
			}
		}
		.fox & {
			h2 {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: Roboto;
				font-size: 30px;
				font-style: normal;
				font-weight: 500;
				line-height: 38px;
				text-transform: none;

				${EmotionBreakpoint('tablet')} {
					font-size: 32px;
					line-height: 32px;
					padding-left: 0px !important;
				}
				${EmotionBreakpoint('mobile')} {
					font-size: 32px;
					line-height: 32px;
					padding-left: 0px !important;
				}
			}
		}
		.law & {
			font-family: 'Oswald';
		}
		.osw & {
			font-family: 'Neue Aachen Pro';
			padding-left: 0;
		}
		.npr & {
			font-family: 'Gotham';
		}

		p {
			color: var(--Base-Black, #222);
			text-align: center;
			font-family: Arial, sans-serif;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%;
			.law & {
				font-family: 'Roboto';
			}
			.bon & {
				color: var(--BA-Primary-Black, #000);
				text-align: center;
				font-family: 'FuturaPT';
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 20px;
			}
			.osw & {
				font-family: 'Roboto';
			}
			.npr & {
				font-family: 'Roboto';
			}
			${EmotionBreakpoint('tablet')} {
				font-size: 14px;
				line-height: 20px;
				text-align: center;
			}
			${EmotionBreakpoint('mobile')} {
				font-size: 14px;
				line-height: 20px;
				text-align: left;
			}
		}
		.fox & {
			p {
				color: var(--Base-Colors-Black, #222);
				text-align: center;
				font-family: Roboto;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 140%;

				${EmotionBreakpoint('tablet')} {
					font-size: 14px;
					line-height: 20px;
					text-align: center;
				}
				${EmotionBreakpoint('mobile')} {
					font-size: 14px;
					line-height: 20px;
					text-align: left;
				}
			}
		}
	}
	.image-cards {
		display: flex;
		align-items: flex-start;
		gap: 24px;
		padding: 0px 70px; /* Keep desktop padding */
		overflow: hidden; /* No scrolling on desktop */
		width: 100%;
		${EmotionBreakpoint('tablet')} {
			overflow-x: auto !important;
			scroll-snap-type: x mandatory;
			white-space: nowrap;
			gap: 13px;
			padding: 0 16px; // <-- better padding for iPad
			width: 100%; // <-- ensure full width
			-webkit-overflow-scrolling: touch;
		}
		${EmotionBreakpoint('mobile')} {
			display: flex;
			overflow-x: auto !important;
			scroll-snap-type: x mandatory;
			white-space: wrap;
			padding: 0px;
			gap: 13px;
			-webkit-overflow-scrolling: touch;
		}
		&::-webkit-scrollbar {
			display: none;
		}
	}
	.image-card {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 307px;

		// Default: 4 pods
		flex: 1 1 calc(25% - 20px);
		${({ podCount }) =>
			podCount === 3 &&
			`
		flex: 1 1 calc(33.33% - 20px);
	`}
		${({ podCount }) =>
			podCount === 2 &&
			`
		flex: 1 1 calc(50% - 20px);
	`}
		${EmotionBreakpoint('tablet')} {
			width: 247px;
			max-width: 247px;
			scroll-snap-align: center;
		}
		${EmotionBreakpoint('mobile')} {
			width: 247px;
			flex: 0 0 auto;
			scroll-snap-align: center;
		}
		.card-eyebrow {
			color: var(--WSJ-Primary-Red-500, #e92440);
			font-family: Arial;
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 140%;
			letter-spacing: 0.56px;
			text-transform: uppercase;
			padding-bottom: 8px;
			${EmotionBreakpoint('tablet')} {
				font-size: 12px;
			}
			${EmotionBreakpoint('mobile')} {
				font-size: 12px;
			}
			.fox & {
				color: var(--Fox-Primary-Blue-500, #2954b6);
				font-family: Roboto;
				font-size: 16px;
				font-style: normal;
				font-weight: 500;
				line-height: 22px;
				letter-spacing: 0.8px;
				text-transform: uppercase;
			}
			.law & {
				color: #cf004f;
				font-family: Roboto;
				font-size: 14px;
				font-weight: 700;
			}
			.bon & {
				color: var(--BonApp-Tertiary-500, #827aba);
				font-family: 'FuturaPT';
				font-size: 18px;
				font-style: normal;
				font-weight: 500;
				line-height: 22px; /* 137.5% */
				letter-spacing: 0.48px;
				text-transform: uppercase;
			}
			.osw & {
				color: #890419;
				font-family: Roboto;
				font-size: 14px;
				font-weight: 700;
			}
			.npr & {
				color: #d62020;
				font-family: Roboto;
				font-size: 14px;
				font-weight: 700;
			}
		}
		.card-title {
			color: var(--WSJ-Primary-Ink-Black, #2b2a2f);
			font-family: Escrow;
			font-size: 24px;
			font-style: normal;
			font-weight: 400;
			line-height: 28px;
			${EmotionBreakpoint('tablet')} {
				font-size: 20px;
			}
			${EmotionBreakpoint('mobile')} {
				font-size: 20px;
			}
			.fox & {
				color: var(--Base-Colors-Black, #222);
				font-family: Roboto;
				font-size: 24px;
				font-style: normal;
				font-weight: 600;
				line-height: 30px;
			}
			.bon & {
				color: #222;
				font-family: 'FuturaPT';
				font-size: 26px;
				font-style: normal;
				font-weight: 450;
				line-height: 30px;
			}
			.law & {
				color: #2b2a2f;
				font-family: 'Noto Serif';
				font-size: 24px;
				font-weight: 400;
			}
			.osw & {
				color: #2b2a2f;
				font-family: 'Neue Haas Grotesk Display Pro';
				font-size: 22px;
				font-weight: 450;
			}
			.npr & {
				color: #2b2a2f;
				font-family: Gotham;
				font-size: 24px;
				font-weight: 600;
			}
		}
		img {
			width: 100%;
			height: auto;
			padding-bottom: 16px;
			padding-top: 16px;
		}
		.card-copy {
			color: var(--Base-Black, #222);
			font-family: Arial;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%;
			text-align: left;
			${EmotionBreakpoint('tablet')} {
				height: auto !important;
				font-size: 14px;
			}
			${EmotionBreakpoint('mobile')} {
				height: auto !important;
				font-size: 14px;
			}
			.fox & {
				color: var(--Base-Colors-Black, #222);
				font-family: Roboto;
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 22px;
			}
			.bon & {
				color: #000;
				font-family: 'FuturaPT';
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 20px; /* 142.857% */
			}
			.law & {
				color: #2b2a2f;
				font-family: Roboto;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
			}
			.osw & {
				color: #2b2a2f;
				font-family: Roboto;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
			}
			.npr & {
				color: #2b2a2f;
				font-family: Roboto;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
			}
		}
	}
`;

// Carousel Controls (Mobile only)
const CarouselControls = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 0px;
	box-sizing: border-box;
	gap: 24px;
	.bon & {
		justify-content: space-between;
	}
	button {
		padding: 3px;
		cursor: pointer;
		background: none;
		border: none;
		font-size: 16px;
		&:disabled {
			cursor: not-allowed;
			opacity: 0.5;
		}
	}
	img {
		${EmotionBreakpoint('mobile')} {
			width: 48px;
			height: 48px;
		}
		${EmotionBreakpoint('tablet')} {
			width: 48px;
			height: 48px;
		}
	}
`;

const DotContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 8px;
	padding-bottom: 5px;
`;

const Dot = styled.button`
	background-color: ${(props) =>
		props.active ? '#E92440' : '#BCBCBC'} !important;
	border-radius: 50%;
	width: 8px;
	height: 8px;
	cursor: pointer;
	border: 1px solid ${(props) => (props.active ? '#E92440' : 'transparent')} !important;
	.bon & {
		background-color: ${(props) =>
			props.active ? '#222' : 'transparent'} !important;
		border: 1px solid ${(props) => (props.active ? '#222' : '#222')} !important;
	}
`;

const ImageCardsSection = ({ contentfulData, brandTag }) => {
	const [mobileView, setMobileView] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);
	const scrollContainerRef = useRef(null);

	const {
		imageCardsSectionHeadline,
		imageCardsSectionDescription = [],
		imageCardEyebrow = [],
		imageCardHeadline = [],
		imageCardCopy = [],
		backgroundColor,
		textColor,
	} = getImageCardSectionFields(contentfulData);

	// `imageCardImage` was NOT moved into the imageCardSection entry — it remains
	// an asset array on the landingPage entry itself.
	const { imageCardImage = [] } = contentfulData || {};

	// Helper to calculate a card's width plus gap (assumed 13px)
	const getCardWidth = () => {
		if (scrollContainerRef.current) {
			const card = scrollContainerRef.current.querySelector('.image-card');
			if (card) {
				// Add gap (13px) to the card width
				return card.offsetWidth + 13;
			}
		}
		return 0;
	};

	useEffect(() => {
		const handleResize = () => {
			const isMobile = window.innerWidth <= 768;
			setMobileView(isMobile);
		};
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (!mobileView || !scrollContainerRef.current) return;
		const handleScrollSync = () => {
			const container = scrollContainerRef.current;
			const scrollLeft = container.scrollLeft;
			const cardWidth = getCardWidth();
			let newIndex = cardWidth ? Math.round(scrollLeft / cardWidth) : 0;
			if (scrollLeft + container.offsetWidth >= container.scrollWidth - 1) {
				newIndex = imageCardHeadline.length - 1;
			}
			setCurrentIndex(newIndex);
		};
		const container = scrollContainerRef.current;
		container.addEventListener('scroll', handleScrollSync);
		return () => container.removeEventListener('scroll', handleScrollSync);
	}, [mobileView, imageCardHeadline.length]);

	const handleScroll = (direction) => {
		if (scrollContainerRef.current) {
			const container = scrollContainerRef.current;
			const cardWidth = getCardWidth();
			let newIndex = direction === 'left' ? currentIndex - 1 : currentIndex + 1;
			if (newIndex < 0) newIndex = 0;
			if (newIndex >= imageCardHeadline.length)
				newIndex = imageCardHeadline.length - 1;
			container.scrollTo({
				left: newIndex * cardWidth,
				behavior: 'smooth',
			});
			setCurrentIndex(newIndex);
		}
	};

	const goToCard = (index) => {
		if (scrollContainerRef.current) {
			const container = scrollContainerRef.current;
			const cardWidth = getCardWidth();
			container.scrollTo({
				left: index * cardWidth,
				behavior: 'smooth',
			});
			setCurrentIndex(index);
		}
	};

	return (
		<SectionContainer
			bgColor={backgroundColor?.value}
			textColor={textColor?.value}
		>
			<div className='section-header'>
				{imageCardsSectionHeadline && <h2>{imageCardsSectionHeadline}</h2>}
				{imageCardsSectionDescription && <p>{imageCardsSectionDescription}</p>}
			</div>
			<div className='image-cards' ref={scrollContainerRef}>
				{imageCardHeadline?.map((title, index) => {
					const podCount = imageCardHeadline?.length; // dynamically pass count
					const eyebrow = imageCardEyebrow?.[index];
					const imageUrl = imageCardImage?.[index]?.fields?.file?.url;
					const copy = imageCardCopy?.[index];
					return (
						<div className='image-card' key={`image-card-${index}`}>
							{eyebrow && <div className='card-eyebrow'>{eyebrow}</div>}
							{title && <div className='card-title'>{title}</div>}
							{imageUrl && <img src={imageUrl} alt={title} />}
							{copy && <div className='card-copy'>{copy}</div>}
						</div>
					);
				})}
			</div>
			{mobileView ? (
				<CarouselControls>
					<button
						onClick={() => handleScroll('left')}
						disabled={currentIndex === 0}
					>
						{brandTag === 'bon' ? <LeftShevron /> : <LeftArrowIcon />}
					</button>
					<DotContainer>
						{imageCardHeadline.map((_, index) => (
							<Dot
								key={index}
								active={index === currentIndex}
								onClick={() => goToCard(index)}
							/>
						))}
					</DotContainer>
					<button
						onClick={() => handleScroll('right')}
						disabled={currentIndex === imageCardHeadline.length - 1}
					>
						{brandTag === 'bon' ? <RightShevron /> : <RightArrowIcon />}
					</button>
				</CarouselControls>
			) : (
				' '
			)}
		</SectionContainer>
	);
};

export { ImageCardsSection };
